import dayjs from 'dayjs';
import fiscalCalendar from '../fiscal-calendar.json';

function addFiscalWeek(dateString) {
  return dateString.concat(" (", fiscalCalendar[dateString], ")");
}

function removeFiscalWeek(dateString) {
  return dateString.slice(0, 10);
}

export function getCannedTimeframeArr(selectedCannedReport) {
  const timeframeArr = [];

  if (selectedCannedReport === 'YTD') {
    selectedCannedReport = getYTDWeeks();
  }

  for (let i = selectedCannedReport; i > 0; i--) {
    const week = dayjs()
      .locale('en-GB')
      .day(0)
      .subtract(i, 'week')
      .format('YYYY-MM-DD');
    timeframeArr.push(addFiscalWeek(week));
  }

  return timeframeArr;
}

export function getMatchState(currentTimeframe, switchOn) {
  const today = dayjs().locale('en-GB');
  const currWeek = today.day(0).format('YYYY-MM-DD');
  const lastAvailableDate = dayjs(currWeek)
    .subtract(108, 'week')
    .locale('en-GB')
    .format('YYYY-MM-DD');

  const prev = getDatesMatchCurrent(currentTimeframe, switchOn);

  let isEarlier = prev.some((dateString) => {
    let date = dayjs(dateString.split(' ')[0]);
    return date.isBefore(lastAvailableDate);
  });
  return isEarlier;
}
export function getDatesMatchCurrent(currTimeframeArr, switchOn) {
  const prev = switchOn
    ? // creates date array for last period
      currTimeframeArr.map((date) => {
        return addFiscalWeek(dayjs(removeFiscalWeek(date))
          .subtract(currTimeframeArr.length, 'week')
          .locale('en-GB')
          .format('YYYY-MM-DD'));
      })
    : // creates date array for last year
      currTimeframeArr.map((date) => {
        return addFiscalWeek(dayjs(removeFiscalWeek(date))
          .subtract(1, 'year')
          .locale('en-GB')
          .day(0)
          .add(1, 'week')
          .format('YYYY-MM-DD'));
      });

  return prev;
}
export function getDatesPreviousYear(
  selectedCannedReport,
  currTimeframeArr,
  switchOn,
) {

  if (selectedCannedReport === 'YTD') {
    selectedCannedReport = getYTDWeeks();
  }

  const prev = switchOn
    ? // creates date array for last period
      currTimeframeArr.map((date) => {
        return addFiscalWeek(dayjs(removeFiscalWeek(date))
          .subtract(selectedCannedReport, 'week')
          .locale('en-GB')
          .format('YYYY-MM-DD'));
      })
    : // creates date array for last year
      currTimeframeArr.map((date) => {
        return addFiscalWeek(dayjs(removeFiscalWeek(date))
          .subtract(1, 'year')
          .locale('en-GB')
          .day(0)
          .add(1, 'week')
          .format('YYYY-MM-DD'));
      });

  return prev;
}

export function getYTDWeeks() {
  const today = dayjs().locale('en-GB');
  const currWeekString = today.day(0).format('YYYY-MM-DD');
  
  return parseInt(fiscalCalendar[currWeekString]) - 1; // Subtract 1 because we exclude the current week.
}

export function encodeDates(timeframeArr) {
  const formattedCurrArray = [];

  timeframeArr.forEach((item) => {
    const formattedItem = item
      .replace(/\s/g, '%20')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');
    formattedCurrArray.push(formattedItem);
  });

  const timeframeVals = formattedCurrArray.join(',');

  return timeframeVals;
}
